import { useCartBrand } from "@faire/retailer-visitor-shared/views/brand/BrandCart/hooks/useCartBrand";
import { useCallback } from "react";
export var useGetCartItemToken = function(brandToken) {
    var cartBrand = useCartBrand(brandToken);
    var findCartItemsByProduct = useCallback(function(productToken) {
        var result = "";
        if (cartBrand) {
            var _Object_values_find;
            var _Object_values_find_token;
            result = (_Object_values_find_token = (_Object_values_find = Object.values(cartBrand.cart_items).find(function(cart_item) {
                return (cart_item === null || cart_item === void 0 ? void 0 : cart_item.product_token) === productToken;
            })) === null || _Object_values_find === void 0 ? void 0 : _Object_values_find.token) !== null && _Object_values_find_token !== void 0 ? _Object_values_find_token : "";
        }
        return result;
    }, [
        cartBrand
    ]);
    return findCartItemsByProduct;
};
